
  <div class="Reorder Inventory">
    <div class="fx-xs-column fx-row fx-align-space-between-center">
      <div class="fx-row fx-align-start-center fx-flex-30" id="header__wrapper">
        <app-count-header title="{{inventory?.invBatchName}}"></app-count-header>
      </div>
      <h2 class="text-center w-100">{{ "report.reorder" | translate }}</h2>
      <div class="flex fx-align-end-center invButton__wrapper fx-flex-30">
        <div class="fx-layout-lt-md-column fx-row fx-gap-30px">
          <button mat-raised-button color="primary" (click)="sendReport()" class="fx-align-simple-center">
            {{ "sendReport" | translate }}
          </button>
          <app-select-report></app-select-report>
          <button mat-raised-button color="primary" (click)="onGeneratePDF()" class="fx-align-simple-center">
            {{ "generatePDF" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <app-mid-header [inventory]="inventory"></app-mid-header>
  <div class="fx-row p-15">
    <div class="fx-flex-50 fx-hide fx-show-sm fx-show-md fx-show-lg fx-show-xl"></div>
    <form [formGroup]="prdMinQtyForm" class="fx-xs-flex-100 fx-xs-column fx-row fx-flex-50 fx-align-end-center">
      <div class="fx-row fx-align-end-center">
        <mat-radio-group formControlName="pcmType" 
          [value]="1" 
          (change)="setMinQty($event)"
          class="fx-xs-row fx-align-xs-space-between-center countType__radio-group form-control w-100">
          <div class="fx-row radio-btn-1 mb-10">
            <mat-radio-button class="countType__radio-button radio-button2" [value]="1">
              <span>{{ settings$?.locMinQtyLabel1 }}</span>
            </mat-radio-button>
          </div>
          <mat-radio-button class="countType__radio-button" [value]="2" *ngIf="settings$?.locEnableMultiMinQty == 1">
            <span>{{ settings$?.locMinQtyLabel2 }}</span>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </form>
  </div>
  <mat-table [dataSource]="dataSource" matSort class="table" style="width: 100%;" (matSortChange)="onSortData($event)">
    <ng-container matColumnDef="prdCode" >
      <mat-header-cell *matHeaderCellDef mat-sort-header> {{ "form.product.prdCode" | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element" class="flex-header">
        <span class="mobile-label">{{ "form.product.countType" | translate }}</span>
        <span [innerHTML]="element.prdCode"></span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="prdNameEn" >
      <mat-header-cell *matHeaderCellDef mat-sort-header> {{ "products.table.prdNameEn" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="flex-header">
        <span class="mobile-label">{{ "products.table.prdNameEn" | translate }}</span>
        <span [innerHTML]="element.prdNameEn"></span>
        <span *ngIf="element.isCombined" style="color: red;">*</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="prdCasePack" >
      <mat-header-cell *matHeaderCellDef mat-sort-header> UOM
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="flex-header">
        <span class="mobile-label">UOM</span>
        <span>{{element.prdCasePack}}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="invitmCount" >
      <mat-header-cell *matHeaderCellDef mat-sort-header> {{ "inventory.count" | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element" class="flex-header">
        <span class="mobile-label">{{ "inventory.count" | translate }}</span>
        <span>{{ element.invitmCount }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="pcmMinQty" >
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ moq == 1 ? settings$.locMinQtyLabel1 : settings$.locMinQtyLabel2}}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="flex-header">
        <span class="mobile-label">{{ moq == 1 ? settings$.locMinQtyLabel1 : settings$.locMinQtyLabel2}}</span>
        <span>{{ moq == 1 ? parseInt(element?.defaultOrderMinQty1) : parseInt(element?.defaultOrderMinQty2)}}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="invOrder" >
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ "order" | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="flex-header">
        <span class="mobile-label">{{ "order" | translate }}</span>
        <span *ngIf="moq == 1"><span [ngClass]=" checkValue(element.invOrder1) ? 'error' : ''">{{ element.invOrder1 }}</span></span>
        <span *ngIf="moq == 2"><span [ngClass]=" checkValue(element.invOrder2) ? 'error' : ''">{{ element.invOrder2 }}</span></span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="pcmDesc" >
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ "inventory.orderBy" | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element" class="flex-header">
        <span class="mobile-label">{{ "inventory.orderBy"| translate }}</span>
        <span>{{ element.defaultOrderDesc }}/ {{ element.defaultOrderItemQty }}</span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" appInventoryRow [prdID]="row.prdID" [invitmID]="row.invitmID">
    </mat-row>
    <div class="mat-row empty-row" *matNoDataRow class="fx-row fx-align-center">
      <p class="mat-cell" colspan="9999">
        <app-no-results message="It appears you don't have any items for reorder.">
        </app-no-results>
      </p>
    </div>
  </mat-table>
  <table class="bottom-table alert-message" *ngIf="hasAsteriskProducts">
    <tr>
      <td>{{ "message_asterisk" | translate }}</td>
    </tr>
</table>
